export const isProductionHostname = (): boolean => {
  const { hostname } = window.location;
  return /^www.storebrand\.no$/i.test(hostname);
};

export const isLocalhostHostname = (): boolean => {
  const { hostname } = window.location;
  return hostname === "localhost";
};

export const isTestHostname = (): boolean => {
  const { hostname } = window.location;
  return /^(www-t|www-ts)\./.test(hostname);
};
